module.exports = __webpack_public_path__ + "img/new-zealand-logo-icon.291ae997.png";